import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../css/client/clientLogin.css";
import { showSuccess, showError } from "../../utils/toast";
import { apiPost } from "../../service/admin/apiService";
import { getDeviceType } from "../../utils/admin/misc";

const ClientLogin = () => {
  const [showModal, setShowModal] = useState(true);
  const [step, setStep] = useState("phone");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [optRec, setOtpRec] = useState(0);
  const [countdown, setCountdown] = useState(10);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [verifyloading, setVerifyLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let timer;
    if (step === "otp" && isOtpSent && countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown, step, isOtpSent]);

  const handleOtpChange = (index, value) => {
    if (value.length <= 1) {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      if (value && index < 3) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleOtpPaste = (e, index) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim();
    if (!/^\d{4}$/.test(pasteData)) return;

    const newOtp = pasteData.split("");
    setOtp(newOtp);

    setTimeout(() => {
      const lastIndex = newOtp.length - 1;
      const lastInput = document.getElementById(`otp-${lastIndex}`);
      if (lastInput) lastInput.focus();
    }, 0);
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "") {
        if (index > 0) {
          const prevInput = document.getElementById(`otp-${index - 1}`);
          if (prevInput) prevInput.focus();

          const newOtp = [...otp];
          newOtp[index - 1] = "";
          setOtp(newOtp);
        }
      } else {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };

  const getOpt = async () => {
    if (loading) return;
    if (phone === "" || phone.length < 10) {
      showError("Please enter valid phone number to proceed");
      return;
    }

    setLoading(true);
    const payload = {
      action: "getotp",
      un: phone,
    };

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
      } else if (response?.responsedetails) {
        console.log("response", response.responsedetails);
        //alert(`OTP: ${response.responsedetails.otp}`);
        setLoading(false);
        if (response?.responsedetails?.success === "yes") {
          setStep("otp");
          setOtpRec(response.responsedetails.otp);
          setIsOtpSent(true);
          setCountdown(10);
          setLoading(false);
        }
      }
    } catch (err) {
      console.error("Login Error:", err);
      showError("Something went wrong");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    if (verifyloading) return;
    const enteredOtp = otp.join("");
    if (enteredOtp === "") {
      showError("Please enter OTP to proceed");
      return;
    }
    setVerifyLoading(true);
    const payload = {
      action: "login",
      un: phone,
      ot: enteredOtp,
      pa: "",
      de: getDeviceType(),
    };

    console.log("login payloa", payload);

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      if (Number(response?.errordetails?.errorcode) > 0) {
        console.log("error", response);
        showError(response?.errordetails?.error);
        setVerifyLoading(false);
      } else if (response?.responsedetails) {
        console.log("login res", response.responsedetails);
        showSuccess("Login successful");
        localStorage.setItem(
          "clientInfo",
          JSON.stringify(response.responsedetails)
        );
        navigate("/client-dashboard");
        setVerifyLoading(false);
      }
    } catch (err) {
      console.error("Login Error:", err);
      showError("Something went wrong");
      setVerifyLoading(false);
    }
  };

  return (
    <Modal show={showModal} centered backdrop="static">
      <Modal.Header className="custom-header">
        <Modal.Title>
          {step === "phone" ? "Login" : "OTP Verification"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {step === "phone" ? (
          <>
            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter your phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getOpt();
                  }
                }}
              />
            </Form.Group>
            <p className="info-text text-muted small">
              We will send you an <strong>one time password</strong> on this
              mobile number.
            </p>
            <Button
              className="w-100 mt-3 btn-primary"
              onClick={() => {
                getOpt();
              }}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2 " />
                  Sending...
                </>
              ) : (
                "Send OTP"
              )}
            </Button>
          </>
        ) : (
          <>
            <p className="text-muted small">
              Enter the 4-digit OTP sent to <strong>{phone}</strong>.
            </p>

            {/* <Row className="mb-3"> */}
            <div className="w-100 d-flex justify-content-center gap-5 mb-2">
              {[0, 1, 2, 3].map((i, index) => (
                <Form.Control
                  key={i}
                  id={`otp-${i}`}
                  type="text"
                  maxLength="1"
                  value={otp[i]}
                  onChange={(e) => handleOtpChange(i, e.target.value)}
                  onPaste={(e) => handleOtpPaste(e, index)}
                  onKeyDown={(e) => handleOtpKeyDown(e, index)}
                  className="text-center"
                  style={{ width: "50px", fontSize: "20px", padding: "5px" }}
                />
              ))}
            </div>

            {/* {[0, 1, 2, 3].map((i, index) => (
                <Col key={i} xs={3}>
                  <Form.Control
                    id={`otp-${i}`}
                    type="text"
                    maxLength="1"
                    value={otp[i]}
                    onChange={(e) => handleOtpChange(i, e.target.value)}
                    onPaste={(e) => handleOtpPaste(e, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    className="text-center"
                    style={{ width: "100%", minWidth: "50px" }}
                  />
                </Col>
              ))} */}
            {/* </Row> */}

            <p className="text-center text-muted small">
              Didn’t receive the OTP?{" "}
              {countdown > 0 ? (
                <span className="text-secondary">
                  Resend OTP in {countdown}s
                </span>
              ) : (
                <span
                  className="resend-link"
                  onClick={() => {
                    getOpt();
                  }}
                >
                  Resend OTP
                </span>
              )}
            </p>

            <Button
              className="w-100 mt-3"
              onClick={() => {
                verifyOtp();
              }}
            >
              {verifyloading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2 " />
                  Verifying...
                </>
              ) : (
                "Verify OTP"
              )}
            </Button>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ClientLogin;
